import { AfterViewInit, Component, EventEmitter, input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-status-summary',
    templateUrl: './status-summary.component.html',
    styleUrls: ['./status-summary.component.scss'],
    standalone: false
})
export class StatusSummaryComponent implements OnChanges, AfterViewInit {
  faChevronRight = faChevronRight;

  user = input.required<any>();
  summaryInfoRegion = input.required<any>();
  summaryInfoForest = input.required<any>();
  @Output() changeFilterCall = new EventEmitter();

  summaryData = new MatTableDataSource<any>();
  displayedColumns = [
    'fire_count',
    'nfs_acres',
    'fire_acres',
    'total_req',
    'ro_auth',
    'wo_auth',
    'total_auth',
    // 'total_exp',
    // 'exp_percent'
  ];

  @ViewChild(MatSort) sort: MatSort = new MatSort;

  ngAfterViewInit(): void {
    this.summaryData.sort = this.sort;
  }

  ngOnChanges(): void {
    this.displayedColumns = this.displayedColumns.filter((item: string) => (item != 'region') && (item != 'forest_name'));
    if (this.summaryInfoRegion()) {
      this.summaryData.data = this.summaryInfoRegion();
    this.summaryData.sort = this.sort;
      this.displayedColumns.unshift('region');
    } else {
      this.summaryData.data = this.summaryInfoForest();
    this.summaryData.sort = this.sort;
      this.displayedColumns.unshift('forest_name');
    }
  }

  changeFilter(type: string, filter_item: string) {
    this.changeFilterCall.emit({ type: type, filter_item: filter_item })
  }
}
